module.exports = __webpack_public_path__ + "static/media/lazarus.a4231133.png";